import { supabase } from "@/lib/supabase";
import type { NotificationType } from "@/lib/api/pushNotifications";

export interface InboxNotification {
  id: string;
  group_id: string;
  user_id: string;
  type: NotificationType | string;
  title: string;
  body: string;
  url: string;
  event_id: string | null;
  read_at: string | null;
  created_at: string;
}

const NOTIFICATIONS_LIMIT = 50;

export async function fetchMyNotifications(
  groupId: string,
  limit = NOTIFICATIONS_LIMIT
): Promise<InboxNotification[]> {
  const { data, error } = await supabase
    .from("notifications")
    .select("*")
    .eq("group_id", groupId)
    .order("created_at", { ascending: false })
    .limit(limit);

  if (error) throw error;
  return (data ?? []) as InboxNotification[];
}

export async function unreadCount(groupId: string): Promise<number> {
  const { count, error } = await supabase
    .from("notifications")
    .select("id", { count: "exact", head: true })
    .eq("group_id", groupId)
    .is("read_at", null);

  if (error) throw error;
  return count ?? 0;
}

export async function markRead(notificationId: string): Promise<void> {
  const { error } = await supabase
    .from("notifications")
    .update({ read_at: new Date().toISOString() })
    .eq("id", notificationId);

  if (error) throw error;
}

export async function markAllRead(groupId: string): Promise<void> {
  const { error } = await supabase
    .from("notifications")
    .update({ read_at: new Date().toISOString() })
    .eq("group_id", groupId)
    .is("read_at", null);

  if (error) throw error;
}
